import FTGUCModel from './engineTypes/FTGUCModel';
import FOWModel from './engineTypes/FOWModel';

export const SUPPORTED_ENGINE_TYPES = ['FTGUC_Model', 'FOW_Model'];

export const ENGINE_TYPE_REGISTRY = {
	FTGUC_Model: {
		component: FTGUCModel,
		getDefault: (defaults) => ({
			...defaults.FTGUC
		})
	},
	FOW_Model: {
		component: FOWModel,
		getDefault: (defaults) => ({
			...defaults.FOW
		})
	}
	// Add More engine types here as needed
};
